import classNames from "classnames";

import { hasHtmlContent } from "../Utils/htmlStringUtils";
import RichText from "../Utils/RichText";
import Icon from "../Utils/Icon";

const PageSectionSidebarBlock = props => {
  const { title, description, children } = props;

  const iconClassName =
    props.iconClassName &&
    classNames(["text-primary", "text-title-section", props.iconClassName]);

  const className = classNames([
    "page-section",
    "card",
    "box",
    "page-section-sidebar-box",
    "border-radius-bottom",
    props.className
  ]);

  return (
    <div className={className}>
      {title && (
        <div className="card-header text-subtitle-page padding-x-md padding-top-md padding-bottom-sm with-icon">
          {iconClassName && <Icon className={iconClassName} />}
          <span className="with-icon-text">{title}</span>
        </div>
      )}

      {hasHtmlContent(description) && (
        <RichText
          className="card-body bg-white padding-x-md padding-y-sm"
          content={description}
        />
      )}

      <div className="card-body bg-white">{children}</div>
    </div>
  );
};

export default PageSectionSidebarBlock;
